// app/main/flight-details/tabs/FlightHistoryTab.tsx
import React, { useEffect, useState, useMemo } from "react";
import { useRouteMatch } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LoadingForm from "../../shared-components/loading-form/LoadingForm";
import flightServices from "app/services/flight.services";
import FlightHistoryItem from "./FlightHistoryItem";

type RouteParams = { id?: string };

const FlightHistoryTab: React.FC = () => {
  const { params } = useRouteMatch<RouteParams>();
  const { t } = useTranslation();

  const [state, setState] = useState<{
    isLoading: boolean;
    items: any[];
    error: string;
  }>({ isLoading: false, items: [], error: "" });

  useEffect(() => {
    if (!params?.id) return;
    setState((s) => ({ ...s, isLoading: true }));
    flightServices.fetchFlightHistory(params.id)
      .then((res) =>
        setState({ isLoading: false, items: res ?? [], error: "" })
      )
      .catch((err) =>
        setState({
          isLoading: false,
          items: [],
          error: err?.data?.message || err?.message || "Error",
        })
      );
  }, [params?.id]);

  const columns = useMemo(
    () => [
      t("app.main.schedules.history.field", "Field"),
      t("app.main.schedules.history.oldValue", "Old value"),
      t("app.main.schedules.history.newValue", "New value"),
      t("app.main.schedules.history.changedBy", "Changed by"),
      t("app.main.schedules.history.changedAt", "Changed at"),
    ],
    [t]
  );

  if (state.isLoading) return <LoadingForm />;

  if (state.error)
    return <div style={{ color: "crimson" }}>{state.error}</div>;

  if (!state.items?.length)
    return (
      <div style={{ opacity: 0.7 ,textAlign:"center"}}>
        {t("app.main.schedules.history.empty", "No history data available for this flight.")}
      </div>
    );

  // sort desc by changedAt so most recent first (if backend isn't already)
  const sorted = [...state.items].sort(
    (a, b) => new Date(b.changedAt).getTime() - new Date(a.changedAt).getTime()
  );

  return (
    <div>
      {sorted.map((row, idx) => (
        <FlightHistoryItem key={`${row.id}-${idx}`} columns={columns} row={row} />
      ))}
    </div>
  );
};

export default FlightHistoryTab;
